import React from 'react';
import Avatar from '@atlaskit/avatar';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/glyph/add';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import { useIntl } from '@atlassian/jira-intl';
import { CellItem } from '../../../common/ui/styled';
import type { Project } from '../../../common/ui/types';
import { messages } from './messages';

const DISPLAY_LIMIT = 5;

type AddProjectsButtonProps = {
	isDisabled: boolean;
	onClick: () => void;
};

const AddProjectsButton = ({ isDisabled, onClick }: AddProjectsButtonProps) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			iconBefore={<AddIcon label="" size="small" />}
			isDisabled={isDisabled}
			onClick={onClick}
		>
			{formatMessage(messages.addProjects)}
		</Button>
	);
};

type ProjectCountButtonProps = {
	count: number;
	isDisabled: boolean;
	onClick: () => void;
};

const ProjectCountButton = ({ count, isDisabled, onClick }: ProjectCountButtonProps) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			iconBefore={<DocumentsIcon label="" size="small" />}
			isDisabled={isDisabled}
			onClick={onClick}
		>
			{formatMessage(messages.totalProjectCount, { projectCount: count })}
		</Button>
	);
};

type ProjectCellProps = {
	isLocked: boolean;
	onClick: () => void;
	projects: Project[];
	totalCount: number;
};

export const ProjectCell = ({ isLocked, onClick, projects, totalCount }: ProjectCellProps) => (
	<>
		{totalCount === 0 && <AddProjectsButton isDisabled={isLocked} onClick={onClick} />}
		{totalCount <= DISPLAY_LIMIT ? (
			projects.map(({ id, name, avatarUrl }) => (
				<CellItem key={id}>
					<Avatar appearance="square" label={name} size="xsmall" src={avatarUrl} />
					<span>{name}</span>
				</CellItem>
			))
		) : (
			<ProjectCountButton count={totalCount} isDisabled={isLocked} onClick={onClick} />
		)}
	</>
);
